<template>
  <div id="ruleRoot">
    <div id="ruleDiv">
      <div id="ruleTitleDiv">
        活动规则
      </div>
      <div id="rlClose" @click="onBackClick()">x</div>
      <div id="ruleContainer">
        <span v-if="$store.state.ruleContent.length < 1">
          <label>红包活动规则暂未配置</label>
        </span>
        <span v-else>
          <div id="ruleContentContainer">
            <span v-for="item in handleContent($store.state.ruleContent)">{{ item }} <br /></span>
          </div>
        </span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    receiveLogs: [],
  },
  data() {
    return {
    }
  },
  components: {
  },
  methods: {
    // 隐藏兑换记录页面
    onBackClick() {
      this.$emit("hiderulepage");
    }
  },
  computed: {
    // 处理规则内容，将每条内容都分割出来，方便换行
    handleContent() {
      return content => {
        // console.log(content);
        // content = content + content;
        if (content) {
          var matchContent = content.match(/\d+\、/g);
          var arrayData = []
          for (let index = 0; index < matchContent.length; index++) {
            const startStr = matchContent[index];
            const startIndex = content.indexOf(startStr)
            if (index != matchContent.length - 1) {
              const endStr = matchContent[index + 1];
              const endIndex = content.indexOf(endStr)
              const value = content.slice(startIndex, endIndex)
              arrayData.push(value)
            } else {
              const value = content.slice(startIndex, content.length)
              arrayData.push(value)
            }
          }
          // console.log(arrayData);
          return arrayData
        }

      };
    },
  }
}
</script>

<style>
#ruleRoot {
  /* background-color: aquamarine; */
  width: 100%;
  height: 70vh;
  position: absolute;
  display: flex;
  justify-content: center;
  align-items: center;
  top: 0;
  left: 0;
  background: rgba(51, 51, 51, 0.5);
  z-index: 2233;
}

#rlClose {
  z-index: 2233;
  width: 25px;
  height: 25px;
  line-height: 25px;
  background-color: #E6E6E6;
  float: right;
  position: absolute;
  top: -12px;
  right: -10px;
  text-align: center;
  border-radius: 25px;
  color: #484848;
}

#ruleDiv {
  background-color: white;
  border-radius: 10px;
  z-index: 2000;
  width: 90%;
  height: 70%;
  position: relative;
  display: flex;
  flex-direction: column;
}

#ruleTitleDiv {
  margin-top: 10px;
  background-color: white;
  color: #3E3E3E;
  font-size: small;
  font-weight: bold;
  width: 100%;
  height: 30px;
  line-height: 30px;
  text-align: center;
  /* border-bottom: 1px solid #B4B4B4; */
}

#ruleContainer {
  /* height: 40vh; */
  overflow-y: auto;
  padding-left: 10px;
  padding-right: 10px;
}

#ruleContainer span {
  color: #303030;
  font-size: xx-small;
  word-spacing: 1px;
  line-height: 180%;
}
</style>


// WEBPACK FOOTER //
// src/views/SdkV3/rule/Rule.vue